import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { AttributeType } from '../../../variants/types';
import AttributeCheckbox from './attribute-checkbox';
import AttributeColor from './attribute-color';
import { AttributeGeneric } from './attribute-generic';
import AttributePrice from './attribute-price';
import AttributeRadio from './attribute-radio';
import AttributeSelect from './attribute-select';
import AttributeSubcategory from './attribute-subcategory';
import { useVariantsStore } from "@/store/variants";
import { useCategoryStore } from "@/store/category";
export function AttributeSide({ type, name, attribute, collapsible = true, order = 0, }) {
    const [isOpen, setIsOpen] = React.useState(true);
    const show = collapsible ? isOpen : true;
    return (_jsxs("div", { className: `filter-attribute order-${order}`, children: [_jsxs("div", { className: "heading", onClick: () => setIsOpen((prev) => !prev), children: [_jsx("h3", { children: name }), collapsible && _jsx("i", { className: `fa-solid fa-chevron-${isOpen ? 'up' : 'down'}` })] }), show && (_jsxs(_Fragment, { children: [type === 'subCategory' && _jsx(AttributeSubcategory, {}), type === 'generic' && _jsx(AttributeGeneric, { type: attribute.type, type2: attribute.type2 }), type === 'price' && _jsx(AttributePrice, {})] }))] }));
}
export function AttributeSideDynamic({ name, attribute, collapsible = true, order = 0, }) {
    const [isOpen, setIsOpen] = React.useState(true);
    const updateSelectedValues = useVariantsStore((state) => state.updateSelectedValue);
    const show = collapsible ? isOpen : true;
    const updateVariantValues = (attribute, value) => {
        const filterAttribute = useCategoryStore.getState().filter.attributes.find((item) => item.id === attribute.id);
        if (filterAttribute) {
            if (filterAttribute.values.includes(value.id)) {
                updateSelectedValues({ attribute, value });
            }
            else if (filterAttribute.values.length > 0) {
                const val = attribute.values.find(item => item.id === filterAttribute.values[0]);
                if (val) {
                    updateSelectedValues({ attribute: attribute, value: val });
                }
            }
        }
    };
    return (_jsxs("div", { className: `filter-attribute order-${order}`, children: [_jsxs("div", { className: "heading", onClick: () => setIsOpen((prev) => !prev), children: [_jsx("h3", { children: name }), collapsible && _jsx("i", { className: `fa-solid fa-chevron-${isOpen ? 'up' : 'down'}` })] }), isOpen && (_jsxs("div", { className: "values", children: [attribute.type === AttributeType.CHECKBOX &&
                        _jsx(AttributeCheckbox, { attribute: attribute, updateVariantValues: updateVariantValues }), attribute.type === AttributeType.RADIO &&
                        _jsx(AttributeRadio, { attribute: attribute, updateVariantValues: updateVariantValues }), attribute.type === AttributeType.COLOR &&
                        _jsx(AttributeColor, { attribute: attribute, updateVariantValues: updateVariantValues }), attribute.type === AttributeType.SELECT &&
                        _jsx(AttributeSelect, { attribute: attribute, updateVariantValues: updateVariantValues })] }))] }));
}
